import { GET_CHANNELS } from "../../Actions/ActionConstants";

function channelReducer(state=null,action){
    switch (action.type) {
        case GET_CHANNELS:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default channelReducer